



























import { mixins } from 'vue-class-component'
import * as R from 'ramda'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAccountAdditionalInfoInput } from '@/modules/Account/interfaces/account-form'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class AccountFormBusiness extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IAccountAdditionalInfoInput }) value!: IAccountAdditionalInfoInput
  @Prop({ type: Number }) readonly recordTypeId!: number

  title = 'Bussiness Information'

  recordTypeIndex = -1

  get additionals () {
    return this.recordTypeIndex !== -1 && this.recordTypes.length > 0
      ? this.recordTypes[this.recordTypeIndex].additionalInfo
      : []
  }

  R = R

  mounted () {
    if (this.recordTypeId) {
      this.parseAdditionalInfo()
    }
  }

  @Watch('recordTypeId')
  onRecordTypeChanged (val: number) {
    if (!val || val === -1) {
      return
    }
    this.parseAdditionalInfo()
  }

  async parseAdditionalInfo () {
    await this.getRecordTypes(RecordTypeMaster.ACCOUNT)
    const { additionalInput, recordTypes, recordTypeId } = this
    this.recordTypeIndex = recordTypes.findIndex(rt => {
      return (+rt.id) === recordTypeId
    })
    if (!this.$R.keys(this.value).length) {
      const addedInput = additionalInput[recordTypes[this.recordTypeIndex].name]
      this.$R.keys(addedInput).map((key: string) => {
        this.value[key] = ''
      })
    }
  }

  validate () {
    return true
  }
}
